import React, { useEffect, useState } from "react";
import axios from "axios";
import { handleGetLocal } from "../../../../services/auth-service";
import { Popup } from "devextreme-react/popup";
import "./CustomFlagsPopup.css";
import { Navigate } from "react-router-dom";
import { logOut } from "../../../../components/Logout";

export const CustomFlagsPopup = ({ isOpen, setIsOpen, recordId, type, onSaved, toastConfig, setToastConfig }) => {
  const [flags, setFlags] = useState([]);
  const [loading, setLoading] = useState(false);
  const pathname = handleGetLocal("pathURL");

  useEffect(() => {
    if (isOpen && recordId && type) {
      setLoading(true);
      axios
        .get(`${process.env.REACT_APP_API_URL}/api/CustomFlag/getCustomFlagData?recordId=${recordId}&Type=${type}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: pathname,
          },
        })
        .then((res) => {
          if (res?.data) {
            setFlags(res.data?.data);
          }
          setLoading(false);
        })
        .catch((err) => {
          if (!err?.response) {
            Navigate(`/error/500`);
          } else if (err?.response?.status == 401) {
            logOut();
          }
        });
    }
  }, [isOpen, recordId, type]);

  // const toggleFlag = (id) => {
  //   setFlags((prev) => prev.map((f) => (f.gCustomFlagID === id ? { ...f, bValue: !f.bValue } : f)));
  // };

  const toggleFlag = (id) => {
    setFlags((prev) =>
      prev.map((f) =>
        f.gCustomFlagID === id
          ? {
              ...f,
              bValue: f.bValue === true || f.bValue === 1 || f.bValue === "1" ? 0 : 1,
            }
          : f
      )
    );
  };

  const handleSave = () => {
    setLoading(true);

    // Prepare final payload in backend's expected format
    const payload = flags.map((f) => ({
      gCustomFlagID: f.gCustomFlagID,
      gRecordID: recordId,
      sName: f.sName,
      sType: type,
      // bValue: f.bValue ? "1" : "0"
      // bValue: f.bValue === true || f.bValue === 1 || f.bValue === "1" ? "1" : "0",
      bValue: f.bValue === true || f.bValue === 1 || f.bValue === "1" ? 1 : 0,

    }));

    axios
      .post(`${process.env.REACT_APP_API_URL}/api/CustomFlag/updateCustomFlagData`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: pathname,
        },
      })
      .then((res) => {
        console.log("Custom flags updated successfully:", res.data);
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          message: "Successfully Updated!",
          type: "success",
        });

        setTimeout(() => {
          setToastConfig({
            ...toastConfig,
            isVisible: false,
            message: "",
            type: "success",
          });
        }, 1400);

        setIsOpen(false);

        // Send only the selected ones to parent for UI update beside pencil
        if (onSaved) onSaved(flags.filter((f) => f.bValue));
      })
      .catch((err) => {
        console.error("Save failed:", err);
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          message: "Update Failed!",
          type: "error",
        });

        setTimeout(() => {
          setToastConfig({
            ...toastConfig,
            isVisible: false,
            message: "",
            type: "error",
          });
        }, 1400);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const handleSave = () => {
  //   setLoading(true);

  //   const selectedFlags = flags
  //     .filter((f) => f.bSelect)
  //     .map((f) => ({
  //       gCustomFlagID: f.gCustomFlagID,
  //       bSelect: true,
  //     }));

  //   const payload = {
  //     gRecordID: recordId,
  //     sType: type,
  //     Flags: selectedFlags,
  //   };

  //   axios
  //     .post(`${process.env.REACT_APP_API_URL}/api/Person/save-edit-custom-flags`, payload, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //         Domain: pathname,
  //       },
  //     })
  //     .then((res) => {
  //       console.log("Save success:", res.data);
  //        setToastConfig({
  //           ...toastConfig,
  //           isVisible: true,
  //           message: "Successfully Updated!",
  //           type: "success",
  //         });

  //         setTimeout(() => {
  //           setToastConfig({
  //             ...toastConfig,
  //             isVisible: false,
  //             message: "Successfully Updated!",
  //             type: "success",
  //           });
  //         }, 1400);
  //       setIsOpen(false);
  //       if (onSaved) onSaved(flags);
  //     })
  //     .catch((err) => {
  //       console.error("Save failed:", err);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  return (
    <Popup
      visible={isOpen}
      onHiding={() => setIsOpen(false)}
      dragEnabled={false}
      showTitle={false}
      hideOnOutsideClick={false}
      width={400}
      height="auto"
    >
      <div className="custom_flags">
        {/* Header */}
        <div className="popup_header">
          <div className="popup_header_title">
            <div className="popup_header_title_data">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="white"
                style={{ marginRight: "8px" }}
              >
                <path
                  d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 
               0-2 .9-2 2v14c0 1.1.9 2 2 
               2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 
               16H5V9h14v11z"
                />
              </svg>
              <p>{type === "Person" ? "Select Person Options" : "Select Docket Options"}</p>
            </div>
            <p className="popup_header_title_para">CF.1</p>
          </div>
          <svg
            onClick={() => setIsOpen(false)}
            style={{ cursor: "pointer" }}
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.72406 0.282539C9.43156 -0.00996077 8.95906 -0.00996077 8.66656 0.282539L4.99906 3.94254L1.33156 0.275039C1.03906 -0.0174609 0.566563 -0.0174609 0.274063 0.275039C-0.0184375 0.567539 -0.0184375 1.04004 0.274063 1.33254L3.94156 5.00004L0.274063 8.66754C-0.0184375 8.96004 -0.0184375 9.43254 0.274063 9.72504C0.566563 10.0175 1.03906 10.0175 1.33156 9.72504L4.99906 6.05754L8.66656 9.72504C8.95906 10.0175 9.43156 10.0175 9.72406 9.72504C10.0166 9.43254 10.0166 8.96004 9.72406 8.66754L6.05656 5.00004L9.72406 1.33254C10.0091 1.04754 10.0091 0.567539 9.72406 0.282539Z"
              fill="white"
            />
          </svg>
        </div>

        {/* Body */}
        <div className="custom_flags_body">
          {loading ? (
            <p>Loading...</p>
          ) : (
            flags.map((f) => (
              <div key={f.gCustomFlagID} className="flag_item">
                <input
                  type="checkbox"
                  // checked={!!f.bSelect}
                  checked={f.bValue === true || f.bValue === 1 || f.bValue === "1"}
                  onChange={() => toggleFlag(f.gCustomFlagID)}
                  id={f.gCustomFlagID}
                />
                <label htmlFor={f.gCustomFlagID} style={{ marginLeft: "8px" }}>
                  {f.sName}
                </label>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        <div className="popup_buttons">
          <button className="btn primary_btn" onClick={handleSave} disabled={loading}>
            Save
          </button>
          <button className="btn" onClick={() => setIsOpen(false)}>
            Cancel
          </button>
        </div>
      </div>
    </Popup>
  );
};
